import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import analyticsLib from '@nerdwallet/analytics';
import { Impression, ImpressionContext } from '@nerdwallet/analytics/react/impression';
import { ElementImpression, ElementInteraction } from '@nerdwallet/nw-client-lib/tracking';
import { Link } from '@nerdwallet/currency';
import classNames from 'classnames';
import { setTrk, TrkTag } from '@nerdwallet/nw-client-lib/trk-helper';
import { CompareGridTabs } from '../compare-grid-tabs/compare-grid-tabs';
import styles from '../comparison-grid.module.less';
import { ENTITY_NAME, EVENT_TYPES, ACTION, INTERACTION_TYPE } from '../../lib/analytics-constants';

var handleCompareCTAClick = function handleCompareCTAClick(impressionId) {
  analyticsLib.track(EVENT_TYPES.ELEMENT_INTERACTED, {
    action: ACTION.NAVIGATE,
    interaction_type: INTERACTION_TYPE.PRESS,
    entity_name: ENTITY_NAME.COMPARE_PAGE_CTA,
    impression_id: impressionId
  });
};

var DEFAULT_GRID_HEADER = 'Compare at-a-glance';
var DEFAULT_LINK_TEXT = 'Or compare in more detail';
export var ComparisonGrid = function ComparisonGrid(_ref) {
  var _params;

  var analytics = _ref.analytics,
      compareHeader = _ref.compareHeader,
      gridTabs = _ref.gridTabs,
      addEntityClickHandler = _ref.addEntityClickHandler,
      hideComparisonGridPanel = _ref.hideComparisonGridPanel,
      removeEntityClickHandler = _ref.removeEntityClickHandler,
      className = _ref.className,
      productType = _ref.productType,
      taxonomy = _ref.taxonomy,
      renderStickyBanner = _ref.renderStickyBanner,
      classes = _ref.classes;
  var gridHeader = compareHeader.gridHeader,
      compareDetailsLink = compareHeader.compareDetailsLink;
  var compareAnchor = setTrk({
    url: compareDetailsLink === null || compareDetailsLink === void 0 ? void 0 : compareDetailsLink.href,
    taxonomy: taxonomy,
    params: (_params = {}, _defineProperty(_params, TrkTag.location, 'marketplace-compare-grid'), _defineProperty(_params, "is_sbsc", true), _params)
  });
  var headerText = gridHeader || DEFAULT_GRID_HEADER;
  var compareLinkText = (compareDetailsLink === null || compareDetailsLink === void 0 ? void 0 : compareDetailsLink.linkText) || DEFAULT_LINK_TEXT;
  return /*#__PURE__*/React.createElement(Impression, {
    className: classNames([styles.compareGrid, className, classes === null || classes === void 0 ? void 0 : classes.grid]),
    entityName: ENTITY_NAME.COMPARISON_GRID,
    eventType: EVENT_TYPES.ELEMENT_IMPRESSION,
    payload: {
      element_name: ENTITY_NAME.COMPARISON_GRID,
      section_name: analytics === null || analytics === void 0 ? void 0 : analytics.sectionName
    }
  }, /*#__PURE__*/React.createElement(ElementImpression, {
    id: ENTITY_NAME.COMPARISON_GRID,
    elementName: ENTITY_NAME.COMPARISON_GRID,
    sectionCategory: analytics === null || analytics === void 0 ? void 0 : analytics.sectionName
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.compareGridHeader, classes === null || classes === void 0 ? void 0 : classes.header)
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.compareGrid__title, classes === null || classes === void 0 ? void 0 : classes.title)
  }, headerText), (compareDetailsLink === null || compareDetailsLink === void 0 ? void 0 : compareDetailsLink.showCompareLink) && /*#__PURE__*/React.createElement(Impression, {
    entityName: ENTITY_NAME.COMPARE_PAGE_CTA,
    eventType: EVENT_TYPES.ELEMENT_IMPRESSION,
    className: styles.compareGrid__link
  }, /*#__PURE__*/React.createElement(ElementImpression, {
    id: "comparison_grid_".concat(ENTITY_NAME.COMPARE_PAGE_CTA),
    elementName: "comparison_grid_".concat(ENTITY_NAME.COMPARE_PAGE_CTA)
  }, /*#__PURE__*/React.createElement(ImpressionContext.Consumer, null, function (impressionContext) {
    return /*#__PURE__*/React.createElement(ElementInteraction, {
      elementCategory: "navigate",
      elementName: "comparison_grid_".concat(ENTITY_NAME.COMPARE_PAGE_CTA),
      id: "comparison_grid_".concat(ENTITY_NAME.COMPARE_PAGE_CTA, "_navigate"),
      type: "CLICK"
    }, /*#__PURE__*/React.createElement(Link, {
      className: classes === null || classes === void 0 ? void 0 : classes.compareLink,
      href: compareAnchor,
      onClick: function onClick() {
        return handleCompareCTAClick(impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId);
      },
      target: "_blank"
    }, compareLinkText));
  })))), /*#__PURE__*/React.createElement(CompareGridTabs, {
    gridTabs: gridTabs,
    addEntityClickHandler: addEntityClickHandler,
    removeEntityClickHandler: removeEntityClickHandler,
    taxonomy: taxonomy,
    productType: productType,
    hideComparisonGridPanel: hideComparisonGridPanel,
    renderStickyBanner: renderStickyBanner,
    classes: classes
  })));
};
ComparisonGrid.defaultProps = {
  compareHeader: {}
};